/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Using the Carousel component to trigger flickity
(function() {
  var customLogoList = document.querySelector('.logo-list_grid');
  if (!customLogoList) return;
  var logoListCarousel = new window.Carousel(customLogoList, {}, JSON.parse(customLogoList.dataset.flickityConfig));
})();


document.addEventListener('variant:changed', function(event) {
 var variant = event.detail.variant; // Gives you access to the whole variant details
 const productSection = event.target;
 const productGallery = productSection.querySelector('[data-color-option-index]');
 if(!productGallery) return;

 const newSelectedColor = variant[productGallery.dataset.colorOptionIndex];
 const allVisibleCells = productSection.querySelectorAll('[data-color-option-value]:not(.CarouselHiddenSlide)');
 const newEnabledCells = productSection.querySelectorAll(`[data-color-option-value="${newSelectedColor}"]`);

 allVisibleCells.forEach((cell) => {
   cell.classList.add('CarouselHiddenSlide');
 });

 newEnabledCells.forEach((cell) => {
   cell.classList.remove('CarouselHiddenSlide');
 });

 const productCarousel = productGallery.querySelector('.Carousel');
 if (!productCarousel) return;

 setTimeout( () => {
   var flkty = Flickity.data('.Product__Slideshow');
   console.log(flkty.cells);

   productSection.querySelectorAll('.Product__Slideshow.Carousel > .Carousel__Cell').forEach((cell) => {
     productCarousel.querySelector('.flickity-slider').appendChild(cell);
   });

   productSection.querySelectorAll('.Product__Slideshow.Carousel .flickity-slider .CarouselHiddenSlide').forEach((cell) => {
     productSection.querySelector('.Product__Slideshow.Carousel').appendChild(cell);
   })


   flkty.reloadCells();
   flkty.selectCell( 0, true, true )
   console.log(flkty.cells);

   const activeDot = productSection.querySelector('.dot[data-color-option-value].is-selected');
   const firstDot = productSection.querySelector('.dot[data-color-option-value]:not(.CarouselHiddenSlide)');
   if(activeDot) activeDot.classList.remove('is-selected');
   if(firstDot) firstDot.classList.add('is-selected');

 }, 333);
});

// Update the product price if the product has a subscription plan
(function() {
  var variantsSelector = document.querySelector('.Product [name= id]');
  var productPrice = document.querySelector('.Product .ProductMeta__Price-js');
  var productComparePrice = document.querySelector('.Product .ProductMeta__Price-js.Price--compareAt');

  window.addEventListener('change', (event) => {
     if (event.target.className.indexOf(('bcpo-')) < 0) return;
     if (!window.productVariantsWithPrice) return;
     if (!productPrice) return;

     var selectorValue = variantsSelector.value;
     if(productPrice.classList.contains('withoutPerMonth')){
        productPrice.innerText = window.productVariantsWithPrice[selectorValue].replace('per month','');
     }else{
        productPrice.innerText = window.productVariantsWithPrice[selectorValue];
     }
     if(productComparePrice){
       if (!window.productVariantsWithComparePrice) return;
       if(productComparePrice.classList.contains('withoutPerMonth')){
          productComparePrice.innerText = window.productVariantsWithComparePrice[selectorValue].replace('per month','');
       }else{
          productComparePrice.innerText = window.productVariantsWithComparePrice[selectorValue];
       }
     }
 });
})();

(function (){
 // Select the node that will be observed for mutations
 const targetNode = document.querySelector(".shopify-block");
 // Options for the observer (which mutations to observe)
 const config = { attributes: true, childList: true, subtree: true };
 let observeStarted = false;

 // Callback function to execute when mutations are observed
 const callback = (mutationList, observer) => {
   for (const mutation of mutationList) {
     if (mutation.type === "childList") {
       if (mutation.target.classList.contains('subscription-radio')) {
        observeStarted = true;
         add3MonthOptions();
         observer.disconnect();
       }
     }
   }
 };

 // Create an observer instance linked to the callback function
 const observer = new MutationObserver(callback);

 // Start observing the target node for configured mutations
 observer.observe(targetNode, config);

 // Later, you can stop observing
 //observer.disconnect();
 function updatePrice(target) {
   let subscriptionPlanOption = document.querySelector(".selected__subscription__plan .is-selected"),
       variantsWrapper = document.querySelector('[data-sub-productid]'),
       variantElement = null,
       sellingPlanOption = 1;

   if(subscriptionPlanOption) sellingPlanOption = subscriptionPlanOption.dataset.optionPosition;
   if(variantsWrapper) variantElement = variantsWrapper.querySelector('[selected]');
   if(target.parentNode.parentNode.classList.contains('subscription-radio') && variantElement){
    if (sellingPlanOption == 1) {
        target.innerHTML = window.theme.Currency.formatMoney(variantElement.dataset.originalPrice, window.theme.moneyFormat);
    } else {
        target.innerHTML = window.theme.Currency.formatMoney(variantElement.dataset.subPrice, window.theme.moneyFormat);
    }
  }
 }
 function add3MonthOptions () {
   let rechargeOptions = document.querySelectorAll('.rc-button-group__options input'),
       subscriptionPeriodWrapper = document.querySelector('.subscription-period__wrapper'),
       activeRechargeOption = document.querySelector('.rc-radio--active input'),
       subscriptionPopup = document.querySelector('.rc-subscription-details'),
       subscriptionOnly = document.querySelector('.rc-template__button-group.rc-subscription-only');
   // show selector based on the default selected value
   if((activeRechargeOption
     && activeRechargeOption.value == "subscription") || subscriptionOnly){
       if(subscriptionPeriodWrapper)
         subscriptionPeriodWrapper.style.display = 'block';
   }
   //show selector based on the change of options
   if(rechargeOptions){
     rechargeOptions.forEach(option => {
       option.addEventListener('change', (e)=>{
         if(e.target.value == 'subscription'){
          if(subscriptionPeriodWrapper) subscriptionPeriodWrapper.style.display = 'block';
          if(subscriptionPopup) subscriptionPopup.style.display = "block";
         }else{
          if(subscriptionPeriodWrapper) subscriptionPeriodWrapper.style.display = 'none';
          if(subscriptionPopup) subscriptionPopup.style.display = "none";
         }
       })
     })
   }
 }
 // update price on variant change
 document.addEventListener('subscription:change', function(){
  let subscriptionPrice = document.querySelector('.subscription-radio .price-label');
  if(subscriptionPrice) updatePrice(subscriptionPrice);
 });
 if(!observeStarted){
  window.addEventListener('load', function(){
    add3MonthOptions();
   });
 }
})()
